<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <DataTable :columns="columns" :key="dataTableKey" :rows="rows" v-if="rows.length" :count="count" :url="'Organizations/Wallet/Requests'" :operations="['orders',{show: {class: 'info',title: 'مشاهده',icon: 'ti-eye'}}]" />
            <div class="alert alert-info mb-0" v-else>
                <p class="mb-0">داده ای یافت نشد</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Transactions',
    data(){
        return {
            columns: [
                {
                    title: 'شناسه',
                    field: 'requestId'
                },
                {
                    title: 'نام مشتری',
                    field: 'customerName'
                },
                {
                    title: 'درخواست',
                    field: 'requestType'
                },
                {
                    title: 'مبلغ کل',
                    field: 'totalAmount'
                },
                {
                    title: 'وضعیت',
                    field: 'flowStepStatusTitle'
                }
            ],
            shippings: {},
            rows: [],
            showLoading: true,
            count: 0,
            dataTableKey: 0
        }
    },
    methods: {
        getData(){
            this.$api.post('Organizations/Wallet/Requests',{page: 1,perPage: 10}).then(({data}) => {
                if(data.status){
                    this.rows = [];
                    data.result.list.map(transaction => {
                        this.rows.push({
                            ...transaction,
                            totalAmount: new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(transaction.totalAmount)
                        });
                    });
                    this.count = data.result.count;
                    this.rows.operations = ['organization.transactions',{show: {class: 'info',title: 'مشاهده',icon: 'ti-eye'}}];
                    this.dataTableKey += 1;
                }
                this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>